// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.scl--empty-position-poster-box{
    width: 100%;
    height: 778px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.scl--empty-ppb-style{
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 15px;
}

.scl--eps-text-on{
    font-family: var(--primary-font);
    font-size: 16px;
    color: rgba(232, 233, 234, 1);
}

.scl--eps-text-to{
    font-family: var(--primary-font);
    font-size: 16px;
    color: rgba(125, 129, 135, 1);
}`, "",{"version":3,"sources":["webpack://./src/component-module/component-services/card/job-filter/empty-job/css/emptyPosition.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,6BAA6B;AACjC","sourcesContent":[".scl--empty-position-poster-box{\n    width: 100%;\n    height: 778px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.scl--empty-ppb-style{\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    gap: 15px;\n}\n\n.scl--eps-text-on{\n    font-family: var(--primary-font);\n    font-size: 16px;\n    color: rgba(232, 233, 234, 1);\n}\n\n.scl--eps-text-to{\n    font-family: var(--primary-font);\n    font-size: 16px;\n    color: rgba(125, 129, 135, 1);\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
